/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { Page, Text, View, Document, StyleSheet, Image, Font } from "@react-pdf/renderer";
import Constants from "../utilities/Constants";
import Strings from "../utilities/Strings";

// Register Roboto Font
Font.register({ family: "RobotoRegular", src: `${process.env.PUBLIC_URL}/fonts/roboto-v20-latin-regular.ttf` });
Font.register({ family: "RobotoMedium", src: `${process.env.PUBLIC_URL}/fonts/Roboto-Medium.ttf` });

var currentSummaryIndex = 0;
// Summary indexes
var terminationOFFPageIndex = 0;
var capacitiveEffectPageIndex = 0;
var highResistancePageIndex = 0;
var invertedPolarityPageIndex = 0;
var noisePageIndex = 0;
var unbalancePageIndex = 0;
var disclaimerPageIndex = 0;
export class TsExpertReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      generatingDate: new Date(),
      // Summary
      firstTerminationOFFPage: -1,
      firstCapacitiveEffectPage: -1,
      firstHighResistancePage: -1,
      firstInvertedPolarityPage: -1,
      firstNoisePage: -1,
      firstUnbalancePage: -1,
      // Summary numbering control
      isFirstTerminationOFFPage: true,
      isFirstCapacitiveEffectPage: true,
      isFirstHighResistancePage: true,
      isFirstInvertedPolarityPage: true,
      isFirstNoisePage: true,
      isFirstUnbalancePage: true,
      // The report itself
      doc: ""
    };

  }

  // ------------------------ Utilities -------------------------
  getDateNow = () => {
    return (
      this.state.generatingDate.getDate()
      + "/"
      + (this.state.generatingDate.getMonth() + 1)
      + "/"
      + this.state.generatingDate.getFullYear()
    );
  }

  getDateTimeNow = () => {
    let year = this.state.generatingDate.getFullYear();
    let month = this.state.generatingDate.getMonth() + 1;
    let day = this.state.generatingDate.getDate();

    if (day < 10) { day = "0" + day; }
    if (month < 10) { month = "0" + month; }

    return (day + "/" + month + "/" + year);
  }

  formatTime = (problem) => {
    if (problem.ntp !== null && problem.ntp === true) {
      let parsedMillis = Date.parse(problem.time);
      let dateToShow = new Date(parsedMillis);
      return dateToShow.toLocaleString("pt-BR");
    }
    else if (problem.time !== undefined && problem.time !== null) {
      const eventTimeInMillis = problem.time * 1000;
      const timeNow = new Date().getTime();
      const time = timeNow - eventTimeInMillis;
      const dateToShow = new Date(time);
      return (dateToShow.toLocaleString("pt-BR"));
    }
    else {
      return Strings.UNKNOWN;
    }
  }

  formatTime2 = (problemTime, ntp) => {
    if (ntp !== null && ntp === true) {
      let parsedMillis = Date.parse(problemTime);
      let dateToShow = new Date(parsedMillis);
      return dateToShow.toLocaleString("pt-BR");
    }
    else if (problemTime !== undefined && problemTime !== null) {
      const eventTimeInMillis = problemTime * 1000;
      const timeNow = this.props.nowMillis;
      const time = timeNow - eventTimeInMillis;
      const dateToShow = new Date(time);
      return (dateToShow.toLocaleString("pt-BR"));
    }
    else {
      return Strings.UNKNOWN;
    }
  }
  /*
    The measurement time that is retrieved from the database comes as a string.
    We had a problem that the time that was being retrieved was not correct. 
    The workarround we found for this was to remove the last two characters of 
    the string and it miraculously it was in the format we nedded 
  */
  formatUptimeStringToRelativeTime = (uptimeInSeconds) => {
    if (uptimeInSeconds !== undefined) {
      let uptimeSubstring = uptimeInSeconds.substring(0, uptimeInSeconds.length - 2);
      let uptimeSubstringNumber = parseInt(uptimeSubstring);
      const uptimeInMillis = uptimeSubstringNumber * 1000;
      const timeNow = new Date().getTime();
      const whenWasTurnedOn = timeNow - uptimeInMillis;
      const dateWhenWasTurnedOn = new Date(whenWasTurnedOn);
      return this.getDateTimeSince(new Date(dateWhenWasTurnedOn));
    }
  }

  getDateTimeSince = (target) => { // target should be a Date object
    let now = new Date(), yd, md, dd, hd, nd, sd, out = [];

    yd = now.getFullYear() - target.getFullYear();
    md = now.getMonth() - target.getMonth();
    dd = now.getDate() - target.getDate();
    hd = now.getHours() - target.getHours();
    nd = now.getMinutes() - target.getMinutes();
    sd = now.getSeconds() - target.getSeconds();

    if (md < 0) { yd--; md += 12; }
    if (dd < 0) {
      md--;
      dd += this.getDaysInMonth(now.getMonth() - 1, now.getFullYear());
    }
    if (hd < 0) { dd--; hd += 24; }
    if (nd < 0) { hd--; nd += 60; }
    if (sd < 0) { nd--; sd += 60; }

    if (yd > 0) out.push(yd + " ano" + (yd === 1 ? "" : "s"));
    if (md > 0) {
      if (md === 1) {
        out.push(md + " mês");
      }
      else {
        out.push(md + " meses");
      }
    }
    if (dd > 0) out.push(dd + " dia" + (dd === 1 ? "" : "s"));
    if (hd > 0) out.push(hd + "h");
    if (nd > 0) out.push(nd + "m");
    //if (sd > 0) out.push(sd + " segundo" + (sd === 1 ? "" : "s"));
    return out.join(" ");
  }

  getDaysInMonth = (month, year) => {
    if (typeof year == "undefined") year = 1999; // any non-leap-year works as default     
    let currmon = new Date(year, month),
      nextmon = new Date(year, month + 1);
    return Math.floor((nextmon.getTime() - currmon.getTime()) / (24 * 3600 * 1000));
  }

  getAnalysisInit = () => {
    let drawDate = this.whenWasTurnedOnAsDate(this.props.uptime);
    let year = drawDate.getFullYear();
    let month = drawDate.getMonth() + 1;
    let day = drawDate.getDate();
    let hour = drawDate.getHours();
    let minutes = drawDate.getMinutes();
    let seconds = drawDate.getSeconds();

    if (day < 10) { day = "0" + day; }
    if (month < 10) { month = "0" + month; }
    if (hour < 10) { hour = "0" + hour; }
    if (minutes < 10) { minutes = "0" + minutes; }
    if (seconds < 10) { seconds = "0" + seconds; }

    return (day + "/" + month + "/" + year + " " + hour + ":" + minutes + ":" + seconds);
  }

  whenWasTurnedOnAsDate = (uptimeInSeconds) => {
    if (uptimeInSeconds !== undefined) {
      const uptimeInMillis = uptimeInSeconds * 1000;
      const timeNow = new Date().getTime();
      const whenWasTurnedOn = timeNow - uptimeInMillis;
      const dateWhenWasTurnedOn = new Date(whenWasTurnedOn);
      return dateWhenWasTurnedOn;
    }
  }

  // ----------------- Header for all the pages -----------------
  getPageHeader = () => {
    return (
      <View fixed>
        <View style={headerStyles.container}>
          <Image src={`${process.env.PUBLIC_URL}/logo_report.png`} style={headerStyles.logo} />
          <Text style={headerStyles.text}>{Strings.TS_EXPERT_REPORT_EXPORT_NAME} - {Strings.CHANNEL} {this.props.channel}</Text>
        </View>
        <View style={headerStyles.line}></View>
      </View>
    );
  }

  // ----------------- Footer for all the pages -----------------
  getPageFooter = (reportPart) => {
    return (
      <View style={footerStyles.container} fixed>
        <View style={footerStyles.line}></View>
        <View>
          <Text style={footerStyles.text} render={({ pageNumber, totalPages }) => {
            this.setFirstPageNumbers(reportPart, pageNumber);
            return (`${this.getDateTimeNow()}, Página ${pageNumber} / ${totalPages}`);
          }} fixed />
        </View>
      </View>
    );
  }

  setFirstPageNumbers = (reportPart, pageNumber) => {
    if (reportPart === "terminationOFF" && this.state.isFirstTerminationOFFPage) {
      this.setState({
        firstTerminationOFFPage: pageNumber + 1,
        isFirstTerminationOFFPage: false
      });
    }
    else if (reportPart === "capacitiveEffect" && this.state.isFirstCapacitiveEffectPage) {
      this.setState({
        firstCapacitiveEffectPage: pageNumber + 1,
        isFirstCapacitiveEffectPage: false
      });
    }
    else if (reportPart === "highResistance" && this.state.isFirstHighResistancePage) {
      this.setState({
        firstHighResistancePage: pageNumber + 1,
        isFirstHighResistancePage: false
      });
    }
    else if (reportPart === "invertedPolarity" && this.state.isFirstInvertedPolarityPage) {
      this.setState({
        firstInvertedPolarityPage: pageNumber + 1,
        isFirstInvertedPolarityPage: false
      });
    }
    else if (reportPart === "noise" && this.state.isFirstNoisePage) {
      this.setState({
        firstNoisePage: pageNumber + 1,
        isFirstNoisePage: false
      });
    }
    else if (reportPart === "unbalance" && this.state.isFirstUnbalancePage) {
      this.setState({
        firstUnbalancePage: pageNumber + 1,
        isFirstUnbalancePage: false
      });
    }
  }

  // ----------------- Generate Report --------------------------
  createReport = () => {
    let doc = <Document
      title={Strings.TS_EXPERT_REPORT_EXPORT_NAME}>
      {this.createIntroPage()}
      {this.createChannelPage(this.props.channel)}
      {this.createSummaryPage()}
      {this.createTerminationOFFPages()}
      {this.createCapacitiveEffectPages()}
      {this.createHighResistancePages()}
      {this.createInvertedPolarityPages()}
      {this.createNoisePages()}
      {this.createUnbalancePages()}
      {this.createDisclaimerPage()}
    </Document>;

    return doc;
  }

  createIntroPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <View style={{ marginTop: "28vh" }} />

        <View style={reusableStyles.mainTitleUpperLine} />

        <Text style={reusableStyles.mainTitle}>{Strings.TS_EXPERT_DP}</Text>
        <Text style={reusableStyles.mainTitle2}>{Strings.ACTIONS_LIST}</Text>

        <View style={reusableStyles.mainTitleBottomLine} />

        {this.getPageFooter()}
      </Page >
    );
  }

  createChannelPage = (channel) => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <View style={{ marginTop: "30vh" }} />

        <View style={{
          height: "1px",
          width: "100px",
          backgroundColor: "black",
          marginLeft: "auto",
          marginRight: "auto"
        }}></View>

        <Text style={{
          textAlign: "center",
          fontSize: 18,
          marginTop: "2vh",
          marginBottom: "2vh",
          fontWeight: "bold",
          fontFamily: "RobotoMedium"
        }}>{Strings.CHANNEL + " " + channel}</Text>

        <View style={{
          height: "1px",
          width: "60px",
          backgroundColor: "black",
          marginLeft: "auto",
          marginRight: "auto"
        }}></View>

        {this.getPageFooter()}
      </Page >
    );
  }

  // ---------------------- Summary ----------------------------
  createSummaryPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={false}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <Text style={reusableStyles.pageTitle}>{Strings.SUMMARY}</Text>

        {this.getSummaryItem(Constants.H1_TERMINATION_OFF_PROBLEM_TYPE)}
        {this.getSummaryItem(Constants.H1_CAPACITIVE_EFFECT_PROBLEM_TYPE)}
        {this.getSummaryItem(Constants.H1_HIGH_RESISTANCE_PROBLEM_TYPE)}
        {this.getSummaryItem(Constants.H1_INVERTED_POLARITY_PROBLEM_TYPE)}
        {this.getSummaryItem(Constants.H1_NOISE_PROBLEM_TYPE)}
        {this.getSummaryItem(Constants.H1_UNBALANCE_PROBLEM_TYPE)}
        {this.getSummaryItem("disclaimer")}

        {this.getPageFooter()}

      </Page>
    );
  }

  getSummaryItem = (type) => {
    if (type === Constants.H1_TERMINATION_OFF_PROBLEM_TYPE && this.props.terminationOFF.length > 0) {
      currentSummaryIndex++;
      terminationOFFPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {terminationOFFPageIndex}. {Strings.H1_TERMINATOR_OFF_LIST_HEADER} {Strings.H1_TERMINATION_OFF_DOTS} {this.state.firstTerminationOFFPage}
        </Text>
      );
    }
    else if (type === Constants.H1_CAPACITIVE_EFFECT_PROBLEM_TYPE && this.props.capacitiveEffect.length > 0) {
      currentSummaryIndex++;
      capacitiveEffectPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {capacitiveEffectPageIndex}. {Strings.H1_CAPACITIVE_EFFECT_LIST_HEADER} {Strings.H1_CAPACITIVE_EFFECT_DOTS} {this.state.firstCapacitiveEffectPage}
        </Text>
      );
    }
    else if (type === Constants.H1_HIGH_RESISTANCE_PROBLEM_TYPE && this.props.highResistance.length > 0) {
      currentSummaryIndex++;
      highResistancePageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {highResistancePageIndex}. {Strings.H1_HIGH_RESISTANCE_LIST_HEADER} {Strings.H1_HIGH_RESISTANCE_DOTS} {this.state.firstHighResistancePage}
        </Text>
      );
    }
    else if (type === Constants.H1_INVERTED_POLARITY_PROBLEM_TYPE && this.props.invertedPolarity.length > 0) {
      currentSummaryIndex++;
      invertedPolarityPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {invertedPolarityPageIndex}. {Strings.H1_INVERTED_POLARITY_LIST_HEADER} {Strings.H1_INVERTED_POLARITY_DOTS} {this.state.firstInvertedPolarityPage}
        </Text>
      );
    }
    else if (type === Constants.H1_NOISE_PROBLEM_TYPE && this.props.noise.length > 0) {
      currentSummaryIndex++;
      noisePageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {noisePageIndex}. {Strings.H1_NOISE_LIST_HEADER} {Strings.H1_NOISE_DOTS} {this.state.firstNoisePage}
        </Text>
      );
    }
    else if (type === Constants.H1_UNBALANCE_PROBLEM_TYPE && this.props.unbalance.length > 0) {
      currentSummaryIndex++;
      unbalancePageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {unbalancePageIndex}. {Strings.H1_UNBALANCE_LIST_HEADER} {Strings.H1_UNBALANCE_DOTS} {this.state.firstUnbalancePage}
        </Text>
      );
    }
    else if (type === "disclaimer") {
      currentSummaryIndex++;
      disclaimerPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} render={({ totalPages }) => (
          `${disclaimerPageIndex}. ${Strings.DISCLAIMER} ${Strings.H1_DISCLAIMER_EXPERT_DOTS} ${totalPages}`
        )} fixed />
      );
    }
  }

  resetSummaryIndexes = () => {
    currentSummaryIndex = 0;
    terminationOFFPageIndex = 0;
    capacitiveEffectPageIndex = 0;
    highResistancePageIndex = 0;
    invertedPolarityPageIndex = 0;
    noisePageIndex = 0;
    unbalancePageIndex = 0;
    disclaimerPageIndex = 0;
  }

  // ----------------- TERMINATION OFF -----------------
  createTerminationOFFPages = () => {
    if (this.props.terminationOFF.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={eventStyles.page}>

          {this.getPageHeader()}

          <Text style={eventStyles.pageTitle} fixed>{terminationOFFPageIndex}{Strings.H1_TERMINATION_OFF_PAGE_TITLE}</Text>

          <Text style={reusableStyles.lastInfoText2}>
            {Strings.H1_TERMINATION_OFF_PAGE_DESCRIPTION}
          </Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.SUGGESTION}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.H1_TERMINATION_OFF_SUGGESTION_2}</Text>

          <Text style={reusableStyles.lastInfoText}>{Strings.H1_TERMINATION_OFF_SUGGESTION_3}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.EVIDENCE}</Text>
          <View style={reusableStyles.subHeaderLine} />

          {this.createTerminationOFFImages()}
          {this.getPageFooter("terminationOFF")}

        </Page>
      );
    }
  }

  createTerminationOFFImages = () => {
    return (
      this.props.terminationOFFImages.map(data => (
        <View key={data.id} wrap={false}>

          <Text style={reusableStyles.leftSubHeaderText}>Dispositivo</Text>
          <View style={reusableStyles.smallSubHeaderLine} />

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>{Strings.CHANNEL}: </Text>
            {this.props.channel}
          </Text>

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>{Strings.AMPLITUDE}: </Text>
            {(data.amplitude).toFixed(2)} {Strings.MILLIVOLT}
          </Text>
          
          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>{Strings.DETECTED_ON}</Text>
            {this.formatTime2(data.time, data.ntp)}
          </Text>

          <Image src={data.wave.imgURI} style={oscilloscopeStyles.chartImgStyle} />

        </View >
      ))
    );
  }

  // ----------------- CAPACITIVE EFFECT -----------------
  createCapacitiveEffectPages = () => {
    if (this.props.capacitiveEffect.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={eventStyles.page}>

          {this.getPageHeader()}

          <Text style={eventStyles.pageTitle} fixed>{capacitiveEffectPageIndex}{Strings.H1_CAPACITIVE_EFFECT_PAGE_TITLE}</Text>

          <Text style={reusableStyles.lastInfoText}>
            {Strings.H1_CAPACITIVE_EFFECT_PAGE_DESCRIPTION}
          </Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.SUGGESTION}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.CAPACITIVE_EFFECT_SUGGESTION_2}</Text>

          <Text style={reusableStyles.tabbedText}>• {Strings.CAPACITIVE_EFFECT_SUGGESTION_3}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.CAPACITIVE_EFFECT_SUGGESTION_4}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.CAPACITIVE_EFFECT_SUGGESTION_5}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.CAPACITIVE_EFFECT_SUGGESTION_6}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.CAPACITIVE_EFFECT_SUGGESTION_7}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.CAPACITIVE_EFFECT_SUGGESTION_8}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.EVIDENCE}</Text>
          <View style={reusableStyles.subHeaderLine} />

          {this.createCapacitiveEffectImages()}
          {this.getPageFooter("capacitiveEffect")}

        </Page>
      );
    }
  }

  createCapacitiveEffectImages = () => {
    return (
      this.props.capacitiveEffectImages.map(data => (
        <View key={data.id} wrap={false}>

          <Text style={reusableStyles.leftSubHeaderText}>Dispositivo</Text>
          <View style={reusableStyles.smallSubHeaderLine} />
          
          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>{Strings.CHANNEL}: </Text>
            {this.props.channel}
          </Text>

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>{Strings.JITTER}: </Text>
            {(data.jitter).toFixed(2)} {Strings.MICROSSECOND}
          </Text>

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>{Strings.DETECTED_ON}</Text>
            {this.formatTime2(data.time, data.ntp)}
          </Text>

          <Image src={data.wave.imgURI} style={oscilloscopeStyles.chartImgStyle} />

        </View >
      ))
    );
  }

  // ----------------- HIGH RESISTANCE -----------------
  createHighResistancePages = () => {
    if (this.props.highResistance.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={eventStyles.page}>

          {this.getPageHeader()}

          <Text style={eventStyles.pageTitle} fixed>{highResistancePageIndex}{Strings.H1_HIGH_RESISTANCE_PAGE_TITLE}</Text>

          <Text style={reusableStyles.lastInfoText}>
            {Strings.H1_HIGH_RESISTANCE_PAGE_DESCRIPTION}
          </Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.SUGGESTION}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.H1_HIGH_RESISTANCE_SUGGESTION_2}</Text>
          <Text style={reusableStyles.normalSpacedText}>{Strings.H1_HIGH_RESISTANCE_SUGGESTION_3}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.EVIDENCE}</Text>
          <View style={reusableStyles.subHeaderLine} />

          {this.createHighResistanceImages()}
          {this.getPageFooter("highResistance")}

        </Page>
      );
    }
  }

  createHighResistanceImages = () => {
    return (
      this.props.highResistanceImages.map(data => (
        <View key={data.id} wrap={false}>

          <Text style={reusableStyles.leftSubHeaderText}>Dispositivo</Text>
          <View style={reusableStyles.smallSubHeaderLine} />
          
          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>{Strings.CHANNEL}: </Text>
            {this.props.channel}
          </Text>

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>{Strings.AMPLITUDE}: </Text>
            {(data.amplitude).toFixed(2)} {Strings.MILLIVOLT}
          </Text>

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>{Strings.DETECTED_ON}</Text>
            {this.formatTime2(data.time, data.ntp)}
          </Text>

          <Image src={data.wave.imgURI} style={oscilloscopeStyles.chartImgStyle} />

        </View >
      ))
    );
  }

  // ----------------- INVERTED POLARITY -----------------
  createInvertedPolarityPages = () => {
    if (this.props.invertedPolarity.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={eventStyles.page}>

          {this.getPageHeader()}

          <Text style={eventStyles.pageTitle} fixed>{invertedPolarityPageIndex}{Strings.H1_INVERTED_POLARITY_PAGE_TITLE}</Text>

          <Text style={reusableStyles.lastInfoText}>
            {Strings.H1_INVERTED_POLARITY_PAGE_DESCRIPTION}
          </Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.SUGGESTION}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.H1_INVERTED_POLARITY_SUGGESTION_2}</Text>
          <Text style={reusableStyles.normalSpacedText}>{Strings.H1_INVERTED_POLARITY_SUGGESTION_3}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.EVIDENCE}</Text>
          <View style={reusableStyles.subHeaderLine} />

          {this.createInvertedPolarityImages()}
          {this.getPageFooter("invertedPolarity")}

        </Page>
      );
    }
  }

  createInvertedPolarityImages = () => {
    return (
      this.props.invertedPolarityImages.map(data => (
        <View key={data.id} wrap={false}>

          <Text style={reusableStyles.leftSubHeaderText}>Dispositivo</Text>
          <View style={reusableStyles.smallSubHeaderLine} />

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>{Strings.ADDRESS}: </Text>
            {data.address}
          </Text>
          
          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>{Strings.CHANNEL}: </Text>
            {this.props.channel}
          </Text>

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>{Strings.DETECTED_ON}</Text>
            {this.formatTime2(data.time, data.ntp)}
          </Text>

          <Image src={data.wave.imgURI} style={oscilloscopeStyles.chartImgStyle} />

        </View >
      ))
    );
  }

  // ----------------- NOISE -----------------
  createNoisePages = () => {
    if (this.props.noise.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={eventStyles.page}>

          {this.getPageHeader()}

          <Text style={eventStyles.pageTitle} fixed>{noisePageIndex}{Strings.H1_NOISE_PAGE_TITLE}</Text>

          <Text style={reusableStyles.lastInfoText}>
            {Strings.H1_NOISE_PAGE_DESCRIPTION}
          </Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.SUGGESTION}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.H1_NOISE_SUGGESTION_2}</Text>

          <Text style={reusableStyles.tabbedText}>• {Strings.H1_NOISE_SUGGESTION_3}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.H1_NOISE_SUGGESTION_4}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.H1_NOISE_SUGGESTION_5}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.H1_NOISE_SUGGESTION_6}</Text>

          <Text style={reusableStyles.normalSpacedText}>{Strings.H1_NOISE_SUGGESTION_7}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.EVIDENCE}</Text>
          <View style={reusableStyles.subHeaderLine} />

          {this.createNoiseImages()}
          {this.getPageFooter("noise")}

        </Page>
      );
    }
  }

  createNoiseImages = () => {
    return (
      this.props.noiseImages.map(data => (
        <View key={data.id} wrap={false}>

          <Text style={reusableStyles.leftSubHeaderText}>Dispositivo</Text>
          <View style={reusableStyles.smallSubHeaderLine} />
          
          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>{Strings.CHANNEL}: </Text>
            {this.props.channel}
          </Text>

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>{Strings.AMPLITUDE}: </Text>
            {(data.amplitudeIdle).toFixed(2)} {Strings.MILLIVOLT}
          </Text>

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>{Strings.DETECTED_ON}</Text>
            {this.formatTime2(data.time, data.ntp)}
          </Text>

          <Image src={data.wave.imgURI} style={oscilloscopeStyles.chartImgStyle} />

        </View >
      ))
    );
  }

  // ----------------- UNBALANCE -----------------
  createUnbalancePages = () => {
    if (this.props.unbalance.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={eventStyles.page}>

          {this.getPageHeader()}

          <Text style={eventStyles.pageTitle} fixed>{unbalancePageIndex}{Strings.H1_UNBALANCE_PAGE_TITLE}</Text>

          <Text style={reusableStyles.lastInfoText}>
            {Strings.H1_UNBALANCE_PAGE_DESCRIPTION}
          </Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.SUGGESTION}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.H1_UNBALANCE_SUGGESTION_2}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.EVIDENCE}</Text>
          <View style={reusableStyles.subHeaderLine} />

          {this.createUnbalanceImages()}
          {this.getPageFooter("unbalance")}

        </Page>
      );
    }
  }

  createUnbalanceImages = () => {
    return (
      this.props.unbalanceImages.map(data => (
        <View key={data.id} wrap={false}>

          <Text style={reusableStyles.leftSubHeaderText}>Dispositivo</Text>
          <View style={reusableStyles.smallSubHeaderLine} />
          
          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>{Strings.CHANNEL}: </Text>
            {this.props.channel}
          </Text>

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>{Strings.UNBALANCE}: </Text>
            {(data.unbalance).toFixed(2) + " %"}
          </Text>

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>{Strings.DETECTED_ON}</Text>
            {this.formatTime2(data.time, data.ntp)}
          </Text>

          <Image src={data.wave.imgURI} style={oscilloscopeStyles.chartImgStyle} />

        </View >
      ))
    );
  }

  // ----------------- Disclaimer -----------------
  createDisclaimerPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <View style={{ marginTop: "30vh" }} />

        <Text style={reusableStyles.pageTitle}>{Strings.END_OF_REPORT}</Text>

        <View style={{ marginTop: "25vh" }} />

        <Text style={{
          fontSize: 14,
          fontFamily: "RobotoMedium",
          marginBottom: "5px"
        }}>
          {Strings.DISCLAIMER}
        </Text>

        <View style={reusableStyles.subHeaderLine} />

        <Text
          style={{
            fontSize: 12,
            marginBottom: 2,
            fontFamily: "RobotoRegular",
            textAlign: "justify"
          }}>
          {Strings.DISCLAIMER_TEXT}
        </Text>

        {this.getPageFooter()}
      </Page >
    );
  }

  // ----------------- Lifecycle Methods ----------------
  render() {
    this.resetSummaryIndexes();
    return (
      this.createReport()
    );
  }
}

const reusableStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 56
  },

  pageTitle: {
    textAlign: "center",
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  subHeaderText: {
    fontSize: 12,
    fontFamily: "RobotoMedium"
  },

  secondSubHeaderText: {
    marginTop: "3vh",
    fontSize: 12,
    fontFamily: "RobotoMedium"
  },

  leftSubHeaderText: {
    fontSize: 14,
    fontFamily: "RobotoMedium",
    textAlign: "left",
  },

  centeredSubHeaderText: {
    marginBottom: "1vh",
    fontSize: 14,
    fontFamily: "RobotoMedium",
    textAlign: "center",
  },

  centeredSecondSubHeaderText: {
    marginTop: "3vh",
    marginBottom: "1vh",
    fontSize: 14,
    fontFamily: "RobotoMedium",
    textAlign: "center"
  },

  subHeaderLine: {
    height: "1px",
    backgroundColor: "black",
    marginTop: "0.5vh",
    marginBottom: "2vh"
  },

  smallSubHeaderLine: {
    height: "1px",
    width: "70px",
    backgroundColor: "black",
    marginTop: "0.5vh",
    marginBottom: "1vh"
  },

  normalText: {
    fontSize: 12,
    marginBottom: 2,
    fontFamily: "RobotoRegular"
  },

  detectedOnText: {
    fontSize: 12,
    marginBottom: "4vh",
    fontFamily: "RobotoRegular"
  },

  boldText: {
    fontSize: 12,
    marginTop: "1vh",
    marginBottom: 4,
    fontFamily: "RobotoMedium"
  },

  normalSpacedText: {
    fontSize: 12,
    marginBottom: "1vh",
    fontFamily: "RobotoRegular"
  },

  lastInfoText: {
    fontSize: 12,
    marginBottom: "2vh",
    fontFamily: "RobotoRegular"
  },

  lastInfoText2: {
    fontSize: 12,
    marginBottom: "4vh",
    fontFamily: "RobotoRegular"
  },

  summaryText: {
    fontSize: 12,
    marginBottom: "1vh",
    fontFamily: "RobotoRegular"
  },

  checkBox: {
    width: 12,
    height: 12,
  },

  mainTitleUpperLine: {
    marginTop: "2vh",
    marginBottom: "2vh",
    marginLeft: "180px",
    height: "1px",
    width: "156px",
    backgroundColor: "black",
  },

  mainTitle: {
    textAlign: "center",
    fontSize: 24,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  mainTitle2: {
    marginTop: "1vh",
    textAlign: "center",
    fontSize: 24,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  mainTitleBottomLine: {
    marginTop: "2vh",
    marginLeft: "206px",
    height: "1px",
    width: "100px",
    backgroundColor: "black",
  },

  noErrors: {
    //marginTop: "28vh",
    textAlign: "center",
    fontSize: 12,
    //marginBottom: "4vh",
    //fontWeight: "bold",
    fontFamily: "RobotoRegular"
  },

  tabbedText: {
    fontSize: 12,
    marginBottom: "1vh",
    marginLeft: 10,
    fontFamily: "RobotoRegular"
  },

  tabbedText2: {
    fontSize: 12,
    //marginBottom: "1vh",
    marginLeft: 10,
    fontFamily: "RobotoRegular"
  },

  doubleTabbedText: {
    fontSize: 12,
    marginBottom: "1vh",
    marginLeft: 20,
    fontFamily: "RobotoRegular"
  },
});

const headerStyles = StyleSheet.create({
  container: {
    display: "inline-flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center"
  },

  logo: {
    width: "92pt",
    height: "30pt",
    marginBottom: "6pt"
  },

  text: {
    fontSize: 12,
    fontFamily: "RobotoMedium"
  },

  line: {
    height: "1px",
    backgroundColor: "black",
    marginTop: "1vh",
    marginBottom: "2vh"
  }
});

const footerStyles = StyleSheet.create({
  container: {
    textAlign: "right",
    position: "absolute",
    bottom: 20,
    left: 40,
    right: 40
  },

  line: {
    height: "1px",
    backgroundColor: "black",
    marginTop: "1vh",
    marginBottom: "1vh"
  },

  text: {
    fontSize: 12,
    fontFamily: "RobotoRegular"
  }
});

const eventStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 20
  },

  pageTitle: {
    fontSize: 18,
    //marginTop: "2vh",
    marginBottom: "2vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableColHeader: {
    width: "34%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  tableColHeader: {
    width: "33%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  horaryTableCol: {
    width: "34%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  tableCol: {
    width: "33%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  solvedTableCol: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "33%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center"
  }
});

const oscilloscopeStyles = StyleSheet.create({
  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  waveTitle: {
    textAlign: "center",
    fontFamily: "RobotoMedium",
    fontSize: 16,
    marginTop: "1vh",
    marginBottom: "1vh"
  },

  chartImgStyle: {
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: "2vh",
    height: "20vh",
    width: "60vw"
  }
});

export default TsExpertReport;
